<template>
  <v-app>
    <Particles
      id="tsparticles"
      :particlesInit="particlesInit"
      :options="particlesOptions"
    />
    <the-header></the-header>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import TheHeader from './components/TheHeader.vue'
import { loadSlim } from "tsparticles-slim";

export default {
  name: 'App',
  components: {
    TheHeader,
  },
  data() {
    return {
      particlesOptions: {
        background: {
          color: {
            value: 'transparent'
          }
        },
        fpsLimit: 60,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: 'push'
            },
            onHover: {
              enable: true,
              mode: 'repulse'
            },
            resize: true
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 0.8,
              size: 40
            },
            push: {
              quantity: 4
            },
            repulse: {
              distance: 200,
              duration: 0.4
            }
          }
        },
        particles: {
          color: {
            value: '#ffffff'
          },
          links: {
            color: '#ffffff',
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1
          },
          collisions: {
            enable: true
          },
          move: {
            direction: 'none',
            enable: true,
            outMode: 'bounce',
            random: false,
            speed: 2,
            straight: false
          },
          number: {
            density: {
              enable: true,
              area: 800
            },
            value: 80
          },
          opacity: {
            value: 0.5
          },
          shape: {
            type: 'circle'
          },
          size: {
            random: true,
            value: 5
          }
        },
        detectRetina: true
      }
    }
  },
  methods: {
    async particlesInit(engine) {
      await loadSlim(engine);
    },
    updateHreflangTags() {
      // 기존 hreflang 태그 제거
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => link.remove());

      const currentPath = this.$route.path;
      const baseUrl = window.location.origin;
      const currentLocale = this.$i18n.locale; // 현재 언어 가져오기
      document.documentElement.setAttribute('lang', currentLocale); // html lang 속성 업데이트
      document.title = this.$t('title'); // 문서 제목 업데이트

      const langs = ['ko', 'en']; // 지원하는 언어 목록
      langs.forEach(lang => {
        let href;
        if (lang === 'ko') {
          // 한국어는 /en/ 이 없는 기본 경로
          href = baseUrl + currentPath.replace(/^\/(ko|en)\/?/, '/');
        } else {
          // 다른 언어는 /lang/ 경로를 가짐
          href = baseUrl + `/${lang}/` + currentPath.replace(/^\/(ko|en)\/?/, '');
        }

        const link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', lang);
        link.setAttribute('href', href.replace(/\/\/+/g, '/').replace(':/', '://')); // 중복 슬래시 제거
        document.head.appendChild(link);
      });

      // x-default hreflang 추가 (기본 언어가 없는 경우)
      const xDefaultLink = document.createElement('link');
      xDefaultLink.setAttribute('rel', 'alternate');
      xDefaultLink.setAttribute('hreflang', 'x-default');
      xDefaultLink.setAttribute('href', baseUrl + currentPath.replace(/^\/(ko|en)\/?/, '/').replace(/\/\/+/g, '/').replace(':/', '://'));
      document.head.appendChild(xDefaultLink);
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.updateHreflangTags();
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  /* margin-top: 10px; */
}

.v-btn:active {
  transform: scale(0.95);
  transition: transform 0.1s ease-in-out;
}
</style>